<template>
    <div class="padding-content white-content mb-4">
        <div class="h2 mb-1"> <span>{{ $t('general.abono', {abono: teatro.texto_abono}) }} {{ index }}</span></div>
        <div class="h5 mb-4 regular" v-if="abono.asiento && abono.asiento.zona_nombre">{{ abono.asiento.zona_nombre }} / {{ $t('general.fila') }}: {{ abono.asiento.fila }} / {{ $t('general.butaca') }} {{ abono.asiento.asiento }}</div>
        <div class="h5 mb-4 regular" v-if="abono.plaza">
            <template v-if="abono.plaza.sector_name">
                {{ abono.plaza.sector_name }} / 
            </template>
            <template v-if="abono.plaza.fila && abono.plaza.butaca">
                {{ $t('general.fila') }}: {{ abono.plaza.fila }} / {{ $t('general.butaca') }} {{ abono.plaza.butaca }}
            </template>
            <template v-else>
                {{ $t('general.plaza') }} {{ abono.plaza.numero }}
            </template>
            <span v-if="abono.plaza.visibilidad_reducida || abono.plaza.porcentaje_visibilidad">
                &nbsp;-&nbsp;
            </span>
            <span v-if="abono.plaza.visibilidad_reducida" class="text-danger">
                {{ $t('visibilidad_reducida.nombre') }}
            </span>
            <span v-if="abono.plaza.porcentaje_visibilidad" class="text-danger">
                : {{ abono.plaza.porcentaje_visibilidad }}%
            </span>
        </div>
        <div class="h5 mb-4 regular" v-if="abono.tipo_abono">{{ abono.tipo_abono.descripcion}}</div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.nombre')" :name="'nombre' + index" rules="required" v-model="abono.nombre" :disabled="bloquear_nombre_y_apellidos_en_renovacion || desactivar" :style="bloquear_nombre_y_apellidos_en_renovacion ? 'text-decoration: line-through; color: grey;' : ''"/>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.apellidos')" :name="'apellidos' + index" rules="required" v-model="abono.apellidos" :disabled="bloquear_nombre_y_apellidos_en_renovacion || desactivar" :style="bloquear_nombre_y_apellidos_en_renovacion ? 'text-decoration: line-through; color: grey;' : ''"/>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <label>{{ $t('formularios.genero') }}</label>
                    <ValidationProvider :name="'genero' + index" rules="required" v-slot="{ errors }">
                        <multiselect
                            :id="'genero' + index"
                            :disabled="desactivar"
                            v-model="abono.genero"
                            :placeholder="$t('formularios.genero')"
                            label="name"
                            track-by="id"
                            :options="generos"
                            class="custom-multiselect"
                            @select="(option, id) => abono.genero_id = id"
                        ></multiselect>
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs error-message"><b>{{ errors[0] }}</b></span>
                    </ValidationProvider>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4" v-if="manager.lfp">
                <div class="form-group">
                    <div v-if="info_text" class="d-flex align-items-center">
                        <label class="mr-1">{{ $t('formularios.documento_identificacion') }}</label>
                        <InfoToolTip :info="info_text" class="pb-1" />
                    </div>
                    <label v-else>{{ $t('formularios.documento_identificacion') }}</label>
                    <ValidationProvider :name="$t('formularios.documento_identificacion')" rules="required|identificacion" v-slot="{ errors }">
                        <input 
                            v-model="abono.dni" 
                            id="dni"
                            type="text" 
                            :disabled="desactivar" 
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" 
                            :placeholder="$t('formularios.documento_identificacion')" 
                        >
                        <span v-if="errors[0]" class="invalid-feedback text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
                    </ValidationProvider>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4" v-else>
                <FormInput :infoText="info_text" :disabled="desactivar" :label="$t('formularios.dni')" :name="'dni' + index" rules="required" v-model="abono.dni" />
            </div>
            
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <label for="fecha_nacimiento">{{ $t('formularios.nacimiento') }}</label>
                    <ValidationProvider :name="'fecha_nacimiento' + index" rules="required" v-slot="{ errors }">
                        <input type="date" v-model="abono.fecha_nacimiento" id="fecha_nacimiento" name="fecha_nacimiento" min="1900-01-01" max="2999-12-31" @input="() => { if (!manager.lfp) debouncedGetPrecio() }">
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs error-message"><b>{{ errors[0] }}</b></span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.email')" :name="'email' + index" rules="required|email" v-model="abono.email" />
            </div>
            <div class="col-12 col-md-6 col-lg-4 mb-2">
                <div class="form-group">
                    <label>{{ $t('formularios.telefono') }}</label>
                    <PhoneInput
                        :key="error_telefono"
                        :name="'telefono' + index" 
                        :phone="abono.telefono ?? null" 
                        :desactivar="desactivar" 
                        :required="true"
                        :error_telefono="error_telefono"
                        @setNumber="(number) => abono.telefono = number"
                        @validNumber="(valid) => abono.telefono_valido = valid"
                    />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Paises :desactivar="desactivar" :errors="errors" @rellenarPais="rellenarPais" v-on:selected="opt => { pais = opt; abono.pais = opt.nombre; }"/>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Provincias :desactivar="desactivar" :errors="errors" :pais="pais.id" :provincia="provincia" v-on:selected="opt => { provincia = opt; abono.provincia = opt.nombre; }"/>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Locations :desactivar="desactivar" :provincia="provincia" :errors="errors" v-on:selected="opt => { abono.localidad = opt.nombre; }"/>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.domicilio')" :name="'domicilio' + index" rules="required" v-model="abono.domicilio" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.cp')" :name="'cp' + index" rules="required" v-model="abono.cp" />
            </div>
            <div v-if="mostrar_iban == true" class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.iban')" :name="'iban' + index" rules="required" v-model="abono.iban" />
            </div>
            <div v-if="mostrar_titular_cuenta == true" class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.titular_cuenta')" :name="'titular_cuenta' + index" rules="required" v-model="abono.titular_cuenta" />
            </div>
            <template v-if="fields && fields.length > 0">
                <div v-for="(field, index) in fields" :key="index" :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-4' : '')">
                    <FieldComponent 
                        :field="field" 
                        :desactivar="desactivar" 
                        v-model="abono.properties[field.name]"
                    />
                </div>
            </template>
            <b-col cols="12" class="mb-3" v-if="teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' && teatro.nombre === 'Real Murcia CF'">
                <hr />
                <h4>¡Murcianista!</h4>
                <p>Esta temporada elige uno de los segundos que forman cada partido en nuestro estadio.</p>
                <p>Si en ese segundo el Real Murcia C.F. consigue marcar un gol, dar una asistencia, tirar al palo, forzar su primer córner o le pitan un penalti a favor, recibirás un regalo.</p>
                <p>Únicamente tendrás que elegir un número del 1 al 5580 (minuto 93) y si este no ha sido elegido será tuyo durante toda la temporada.</p>
                
                <b-row>
                    <b-col lg="6">
                        <ValidationProvider :name="'segundo_elegido' + index" :mode="manualMode" rules="required" v-slot="{ errors }">
                            <label for="segundo_elegido">Escribe Tu segundo</label>
                            <input type="number" 
                                   v-model="abono.segundo_elegido" 
                                   id="segundo_elegido" 
                                   name="segundo_elegido" 
                                   min="1" 
                                   max="5580"
                                   @input="debouncedValidarSegundos(abono.segundo_elegido)"
                                   :disabled="desactivar">
                            <span v-if="errors[0]" class="invalid-feedback mb-2 text-xs error-message"><b>{{ errors[0] }}</b></span>                        
                        </ValidationProvider>
                        <label for="segundos_sugeridos" v-if="segundos_sugeridos.length > 0">Segundos sugeridos disponibles</label>
                        <div v-if="segundos_sugeridos.length > 0">
                            <b-button 
                                v-for="(segundo, index) in segundos_sugeridos" 
                                :key="index" 
                                variant="outline-primary" 
                                class="m-1"
                                @click="() => { abono.segundo_elegido = segundo; debouncedValidarSegundos(abono.segundo_elegido); }"
                            >
                                {{ segundo }}
                            </b-button>
                        </div>
                    </b-col>
                    <b-col lg="6" v-if="abono.segundo_elegido" class="my-auto text-center">
                        <span class="price price-large">⏰ {{ formatSeg(abono.segundo_elegido) }}</span>
                    </b-col>
                </b-row>
            </b-col>
            <div class="col-12 col-md-6 col-lg-12 pt-2" v-if="mostrar_tipo_abonos">
                <div class="form-group">
                    <div class="d-flex">
                        <label class="mr-2" for="descuento">{{ $t('formularios.tipo_abono', {abono: teatro.texto_abono}) }}</label>
                        <label for="descuento" v-if="teatro.texto_extra_en_compra_de_abono">{{ teatro.texto_extra_en_compra_de_abono }}</label>
                    </div>
                    <ValidationProvider :name="'descuento' + index" rules="required" v-slot="{ errors }">
                        <multiselect
                            :disabled="desactivar"
                            :class="(errors[0] ? 'is-invalid' : '')"
                            v-model="abono.tipo_abono"
                            :placeholder="$t('formularios.tipo_abono', {abono: teatro.texto_abono})"
                            label="descripcion"
                            track-by="id"
                            :options="getTiposPrecios(abono)"
                            @input="() => { if (!manager.lfp) getPrecio() }"
                        ></multiselect>                        
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ $t('formularios.seleccione_tipo_abono') }}</b></span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-12" v-if="precio && precio.solicitar_documentacion">
                <label>{{ precio.texto_documentacion }}</label>
                <Dropzone 
                    v-if="url"
                    :url="url"
                    :maxFilesize="maxFilesize"
                    :maxFiles="5"
                    @success="imagenSubida"
                    :acceptedFiles="'image/jpeg,image/png,image/gif,image/bmp,image/tiff,application/pdf,.pdf'"
                />
                <h3 style="font-size: 19px;">Peso máximo de imágenes: {{ maxFilesize }} MB</h3>
            </div>
            <div class="col-12 form-group mt-3" v-if="teatro.url_whatsapp_abonos">
                <div class="checkbox-container">
                    <input type="checkbox" :name="'envio-whatsapp-' + index" :id="'envio-whatsapp-' + index" :disabled="desactivar" v-model="abono.envio_whatsapp">
                    <label :for="'envio-whatsapp-' + index">{{ $t('formularios.acepto_envio_whatsapp', { termino: 'abonos', coste_envio_whatsapp: coste_envio_whatsapp }) }}</label>
                </div>
            </div>
            <div class="col-12">
                <h3 class="text-danger" >{{ error === 'no precios' ? $t('nuevo_abono.error_precio') : error }}</h3>
            </div>
        </div>
    </div>
</template>

<script>
import Dropzone from '@/components/common/Dropzone';
import Provincias from "../../../common/forms/Provincias";
import Locations from "../../../common/forms/Locations";
import Paises from "../../../common/forms/Paises";
import PhoneInput from '@/components/common/PhoneInput.vue';
import FieldComponent from '@/components/common/FieldComponent.vue';
import _ from 'lodash';

export default {
    props: ['abono', 'generos', 'index', 'descuentos', 'tipos_abonos', 'tipo_abono_id', 'desactivar', 'validator', 'error_telefono'],
    data() {
        return {
            error: null,
            mostrar_tipo_abonos: false,
            precio: null,
            dropzoneOptions: {},
            maxDate: null,
            errors: [],
            provincia: null,
            pais: { id: 0 },
            mostrar_iban: this.$store.getters.getTeatro.mostrar_iban,
            mostrar_titular_cuenta: this.$store.getters.getTeatro.mostrar_titular_cuenta,
            bloquear_nombre_y_apellidos_en_renovacion: this.abono.n_abonado_antiguo ? this.$store.getters.getTeatro.bloquear_nombre_y_apellidos_en_renovacion : false,
            url: null,
            maxFilesize: 20,
            info_text: "A modo informativo queremos aconsejarle que sea cuál sea el formato en el que introduzca el DNI lo recuerde para posibles futuros procesos",
            segundos_sugeridos: []
        }
    },
    created() {
        this.setMaxDate();

        if (this.teatro.provincia) {
            this.provincia = this.teatro.provincia;
        }

        this.abono.properties = {};

        // Debounce para getPrecio
        this.debouncedGetPrecio = _.debounce(this.getPrecio, 500);

        // Debounce para validarSegundos
        this.debouncedValidarSegundos = _.debounce(this.validarSegundos, 500);
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        tipos_renovacion() {
            var tipos = [];
            for(var i in this.tipos_abonos) {
                if(this.tipos_abonos[i].renovacion &&  !this.tipos_abonos[i].exclusivo_penista) {
                    tipos.push(this.tipos_abonos[i]);
                }
            }
            return tipos;
        },
        tipos_nuevo() {
            var tipos = [];
            for(var i in this.tipos_abonos) {
                if(this.tipos_abonos[i].renovacion == 0 && !this.tipos_abonos[i].exclusivo_penista) {
                    tipos.push(this.tipos_abonos[i]);
                }
            }
            return tipos;
        },
        tipos_penista() {
            var tipos = [];
            for(var i in this.tipos_abonos) {
                if(this.tipos_abonos[i].exclusivo_penista == 1) {
                    tipos.push(this.tipos_abonos[i]);
                }
            }
            return tipos;
        },
        teatro(){
            return this.$store.getters.getTeatro;
        },
        lista_abonados() {
            return this.$store.getters.getListaAbonados;
        },
        fields() {
            return this.lista_abonados.fields;
        },
        manager() {
            return this.$store.getters.getFooter;
        },
        coste_envio_whatsapp() {
            return parseFloat(this.teatro.coste_envio_whatsapp);
        }
    },
    mounted() {
        this.$emit('errorDatos', false);
        if(this.abono.n_abonado_antiguo) {
            if(this.abono.penista && this.tipos_penista.length > 0) {
                if(this.tipos_penista.length > 1) {
                    this.mostrar_tipo_abonos = true;
                } else if(this.tipos_penista.length == 1) {
                    this.abono.tipo_abono = this.tipos_penista[0];
                }
            } else {
                if(this.tipos_renovacion.length > 1) {
                    this.mostrar_tipo_abonos = true;
                } else if(this.tipos_renovacion.length == 1) {
                    this.abono.tipo_abono = this.tipos_renovacion[0];
                    this.mostrar_tipo_abonos = false;
                } else {
                    this.error = 'Esta zona no esta disponible';
                    this.mostrar_tipo_abonos = false;
                    this.$emit('errorDatos', true);
                }
            }
        } else {
            if(this.tipos_nuevo.length > 1) {
                this.mostrar_tipo_abonos = true;
            } else if(this.tipos_nuevo.length == 1) {
                this.abono.tipo_abono = this.tipos_nuevo[0];
                this.mostrar_tipo_abonos = false;
            } else {
                this.error = 'Esta zona no esta disponible';
                this.mostrar_tipo_abonos = false;
                this.$emit('errorDatos', true);
            }
        }
        if (this.abono.fecha_nacimiento && !this.manager.lfp) {
            this.getPrecio();
        }
    },
    methods: {
        // Modo manual: sin eventos de validación automática
        manualMode() {
            return {};
        },
        formatSeg(segundo) {
            const minutes = Math.floor(segundo / 60);
            const remainingSeconds = segundo % 60;
            return `Min: ${minutes} - Seg: ${remainingSeconds}`;
        },
        validarSegundos(segundos) {
            const fieldName = 'segundo_elegido' + this.index;
            this.validator.setErrors({ [fieldName]: [] });

            if (segundos > 5580) {
                this.validator.setErrors({
                    [fieldName]: ['El segundo seleccionado supera el máximo permitido (5580 segundos).']
                });
                return;
            }

            const params = {
                lista_id: this.lista_abonados.id,
                filters : {},
                segundo_elegido: segundos
            };

            this.$store.dispatch(this.config.getVuexAlias('front.temporada.segundos.disponible'), params).then(res => {
                const fieldName = 'segundo_elegido' + this.index;
                this.validator.setErrors({ [fieldName]: [] });    
                this.segundos_sugeridos = [];            
            }).catch(error => {
                this.segundos_sugeridos = error.response.data.segundos_sugeridos;
                const errors = [];
                const fieldName = 'segundo_elegido' + this.index;
                errors[fieldName] = ['El segundo seleccionado no esta disponible'];
                this.validator.setErrors(errors);
            });
        },
        getTiposPrecios(abono) {
            if(abono.n_abonado_antiguo) {
                if(abono.penista && this.tipos_penista.length > 0) {
                    return this.tipos_penista;
                } else {
                    return this.tipos_renovacion;
                }
            } else {
                return this.tipos_nuevo;
            }
        },
        setMaxDate() {
            var date = new Date();
            this.maxDate = date.toISOString();
        },
        getPrecio() {
            if(this.abono.fecha_nacimiento && this.abono.tipo_abono) {
                if(this.abono.asiento) {
                    const params = {
                        filters: {
                            tid: this.configuracion.hash_teatro,
                            zona_id: this.abono.asiento ? this.abono.asiento.zona_id : null
                        },
                        tid: this.configuracion.hash_teatro,
                        fecha_nacimiento: this.abono.fecha_nacimiento,
                        zona_id: this.abono.asiento ? this.abono.asiento.zona_id : null,
                        tipo_abono: this.abono.tipo_abono
                    }

                    this.$store.dispatch(this.config.getVuexAlias('zonas.calcular.precio'), params)
                        .then(res => {
                            this.setDropZone();
                            this.precio = res.data.data;
                            this.abono.precio = res.data.data;

                            if(this.error){
                                this.error = '';
                                this.$emit('errorDatos', false);
                            }

                            this.mostrar_tipo_abonos = true;

                        })
                        .catch(error => {
                            this.error = 'no precios';
                            this.mostrar_tipo_abonos = false;
                            this.$emit('errorDatos', true);
                        });

                } else {                        
                    var params_2 = {
                        filters: {
                            tid: this.configuracion.hash_teatro,
                            abono_id: this.abono.tipo_abono.id
                        },
                        tid: this.configuracion.hash_teatro,
                        fecha_nacimiento: this.abono.fecha_nacimiento,
                        abono_id: this.abono.tipo_abono.id,
                        datos_comprador: this.abono
                    }

                    this.$store.dispatch(this.config.getVuexAlias('front.abonos.precios.calcular.precio'), params_2)
                        .then(res => {
                            this.setDropZone();
                            this.precio = res.data.data;
                            this.abono.precio = res.data.data;

                            if(this.error){
                                this.error = '';
                                this.$emit('errorDatos', false);
                            }

                            this.mostrar_tipo_abonos = true;

                        })
                        .catch(error => {
                            this.error = 'no precios';
                            this.mostrar_tipo_abonos = false;
                            this.$emit('errorDatos', true);
                        });
                }      
            }

        },
        imagenSubida(file, response) {
            if(!this.abono.documentaciones) {
                this.abono.documentaciones = [];
            }
            this.$emit('imagenSubida');
            this.abono.documentaciones.push(response);
        },
        setDropZone() {
            this.url = this.config.API_BASE + '/f/upload/documento?tid=' + this.configuracion.hash_teatro;
        },
        rellenarPais(pais) {
            this.abono.pais = pais.nombre;
        }
    },
    components: {
        Locations,
        Provincias,
        Paises,
        Dropzone,
        PhoneInput,
        FieldComponent
    }
}
</script>

<style scoped>
    #paso3 .multiselect__tags {
        background-color: #f1f1f1 !important;
        border-color: #ccc;
    }

    .dropzone-preview {
        position: relative;
        z-index: 1;
    }

    .price-large {
        font-size: 40px !important;  
    }
    .lightgray-content .checkbox-container input[type="checkbox"] + label:before, .lightgray-content .checkbox-container input[type="radio"] + label:before {
        background-color: #ededed;
    }
    .price-large {
        font-size: 40px !important;
        margin-bottom: 4em;
    }
    .price {
        margin-bottom: 4em;
    }
    .mb-3 {
        justify-content: center;
        align-items: center;
    }
    .my-auto {
        padding-top: 1em;
        padding-bottom: 1em;
        margin-top: 20em;
        font-family: 'Noway';
    }
    hr{
        width: 100%;
        height: 2px;
        margin-top: 1em;
        margin-bottom: 1em;
    }
    @media (max-width: 768px) {
        .price-large {
            font-size: 30px !important;
            margin-left: 0px;
        }
    }
    .error-message {
        font-size: 11px;
        display: block;
        background-color: #DC3545;
        color: white;
        padding: 6px;
    }
</style>
